import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Musco CRM — entry point
 *
 * La configuración de dominio (title, sectores, etapas, categorías, moneda,
 * etc.) vive en `src/components/atomic-crm/root/defaultConfiguration.ts` —
 * editar ahí para cambiar los valores iniciales. Los usuarios admin también
 * pueden modificarlos vía la página Settings del CRM.
 *
 * Branding visual (amarillo Musco #FFD200 sobre negro #1A1A1A) configurado
 * en `src/index.css` vía CSS variables (Tailwind v4 + shadcn).
 *
 * Locale por defecto: español (configurado en
 * `providers/commons/i18nProvider.ts`).
 */
const App = () => <CRM disableTelemetry />;

export default App;
